/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Inject, Injectable } from '@angular/core';
import { LOGGED_IN_CONTEXT_SERVICE } from '@irian-ro/auth-shared-module';
import { LoggedInContextService } from './logged-in-context.service';
import { Observable } from 'rxjs';
import { LoggedInContext } from './logged-in-context.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WellContextService {
  constructor(@Inject(LOGGED_IN_CONTEXT_SERVICE) private loggedInContextService: LoggedInContextService) {}

  getLoggedInContext(): Observable<LoggedInContext> {
    return this.loggedInContextService.getLoggedInContext();
  }

  isEmailAuth() {
    return this.loggedInContextService.getLoggedInContext().pipe(
      map((data) => {
        return data.loggedInUser?.authType === 'authEmail';
      })
    );
  }

  isServiceProviderWithEmailAuthType() {
    return this.loggedInContextService.getLoggedInContext().pipe(
      map((data) => {
        return data.loggedInUser?.authType === 'authEmail' && data.serviceProvider;
      })
    );
  }
}
